require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-hazel-dell-crossing.json") })
        }
      }, "path---articles-tags-hazel-dell-crossing");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-hazel-dell-crossing!./.cache/json/articles-tags-hazel-dell-crossing.json
// module id = 1836
// module chunks = 231608221292675